import styles from './ErrorPage.module.scss'

const ErrorPage = () => (
  <div className={styles.container}>
    <h1>Something went wrong</h1>
    <p>
      If you are getting this error consistently, reach our technical support using
      Intercom on bottom right corner.
    </p>
    <a href="/">
      <button>Go back to home</button>
    </a>
  </div>
)

export default ErrorPage
